export enum OrderType {
  ASC = 'asc',
  DESC = 'desc'
}

export enum OrderBy {
  NAME = 'name',
  CREATEDAT = 'createdAt',
  STATUS = 'status',
  TYPE = 'type'
}